import React from "react";
import { useCountdown } from "../hooks/useCountdown";
export function CountdownTimer() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    label: "Hours",
    value: hours
  }, {
    label: "Minutes",
    value: minutes
  }, {
    label: "Seconds",
    value: seconds
  }];
  return <div className="w-full" role="timer" aria-live="off" data-id="element-97" data-mp="1oda7taxvlhbx">
      <p className="mb-3 text-center text-xs font-bold uppercase tracking-[0.18em] text-alert" data-id="element-98" data-mp="1oanzh935uxsn">
        The promotional price expires in
      </p>
      <div className="flex items-start justify-center gap-2 sm:gap-3" data-id="element-99" data-mp="1fasjmqynuema">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-100" data-mp="1adscecq2r5tl" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-101" data-mp="1aetrqte4ieh4">
              <span className="flex h-16 w-[4.5rem] items-center justify-center rounded-xl bg-ink font-mono text-3xl font-black tabular-nums text-cream ring-1 ring-alert/50 sm:h-20 sm:w-24 sm:text-4xl" data-id="element-102" data-mp="15epfxgo5u7x8">
                {String(u.value).padStart(2, "0")}
              </span>
              <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-wider text-muted" data-id="element-103" data-mp="1c05fnnmfm3ns">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className="pt-4 text-2xl font-black text-alert sm:pt-5 sm:text-3xl" aria-hidden="true" data-id="element-104" data-mp="122in3yc7mdlc">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}